import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../services/alert.service';
import { Api } from '../../services/api';

@Component({
  standalone: true,
  selector: 'app-mdlContract-status-reminder',
  imports: [FormsModule, NgSelectModule, CommonModule],
  templateUrl: './mdlContract-status-reminder.html',
  styleUrls: ['./mdlContract-status-reminder.css']
})
export class MdlChangeContractStatus implements OnInit {
   mode: 'estado' | 'recordatorio';
  selectedEstado: string = '';
  selectedRecordatorio: { valor: number; unidad: string } | null = null;

  estados = [
    { label: 'Borrador', value: 'Borrador' },
    { label: 'En espera de aprobación', value: 'En espera de aprobación' },
    { label: 'Activado', value: 'Activado' }
  ];

  recordatorios = [
    { label: '7 días antes', valor: 7, unidad: 'días' },
    { label: '15 días antes', valor: 15, unidad: 'días' },
    { label: '30 días antes', valor: 30, unidad: 'días' },
    { label: '2 meses antes', valor: 2, unidad: 'meses' },
    { label: '3 meses antes', valor: 3, unidad: 'meses' },
    { label: '6 meses antes', valor: 6, unidad: 'meses' },
    { label: '12 meses antes', valor: 12, unidad: 'meses' }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mdl: MatDialogRef<MdlChangeContractStatus>,
    private api: Api,
    private alertService: AlertService
  ) {
    this.mode = data.mode; 
  }

  ngOnInit(): void {}

  closemodal() {
    this.mdl.close();
  }

  saveChanges() {
    const ids = this.data?.ids || [];

    if (this.mode === 'estado') {
      if (!this.selectedEstado) {
        this.alertService.warning('Seleccionar estado', 'Debes seleccionar un estado');
        return;
      }

      this.api
        .updateContractStatus({
          contrato_id: ids,
          estado: this.selectedEstado
        })
        .subscribe({
          next: (res: any) => {
            this.alertService.success('Estado actualizado', 'Estado actualizado correctamente');
            this.mdl.close(true);
          },
          error: (err) => {
            console.error(err);
            this.alertService.error('Error al actualizar', 'Error al actualizar estado');
          }
        });
    }

    if (this.mode === 'recordatorio') {
      if (!this.selectedRecordatorio) {
        this.alertService.warning('Seleccionar recordatorio', 'Debes seleccionar un recordatorio');
        return;
      }

      this.api
        .updateContractReminder({
          contrato_id: ids,
          recordatorio_valor: this.selectedRecordatorio.valor,
          recordatorio_unidad: this.selectedRecordatorio.unidad
        })
        .subscribe({
          next: (res: any) => {
            this.alertService.success('Recordatorio asignado', 'Recordatorio asignado correctamente');
            this.mdl.close(true);
          },
          error: (err) => {
            console.error(err);
            this.alertService.error('Error al asignar', 'Error al asignar recordatorio');
          }
        });
    }
  }
}